import React from "react";
import { formatValidInput } from "../../../helpers/FormatHelper";
import { getStyle } from "../../../styles/styles";
import AlertBox from "../../shared/AlertBox";
import { saveBNFeeStructure } from "../../../networking/NetworkingFeeStructure";
import { validate } from "../../../helpers/ValidateHelper";

var style = getStyle();
export default class BNFeeStructureForm extends React.Component {
    state = {
        notFirstLoad:false,
        feeStructureId:'',
        description:'',
        default:false,
        updateToken: '',
        showAlert:false,
        alertTitle: '',
        alertMessage:'',
        showAlertError: false,
        errors:[],
        validations: {
            description: true
        }
    }

    componentDidMount(){}

    updateInputs = () =>{
        var feestructure = this.props.selectedFeeStructure;
        var feestructureID = 0;
        if(feestructure['FeeStructureID'] !== null){
            feestructureID = feestructure['FeeStructureID'];
        }

        this.setState({
            feeStructureId: feestructureID,
            description: feestructure['Description'],
            default: feestructure['Default'],
            updateToken: feestructure['UpdateToken']
        });
    }

    componentDidUpdate(prevProps){
        if(this.props.selectedFeeStructure!== {} && prevProps.selectedFeeStructure !== this.props.selectedFeeStructure){
            this.updateInputs()  
        };
        if(this.props.clearForm !== {} && this.props.clearForm === true){
            this.setState({
                feeStructureId: '',
                description: '',
                default: false,
                updateToken: ''          
            });
            this.props.outClearForm(false);
        }
    }

    handleUpdateDescription(event){
        this.setState({validations: {...this.state.validations, description: true},description: event.target.value});
    }
    
    handleUpdateDefault(event){
        this.setState({
            default: event.target.checked
        })
    }    

    handleClearClick = (event) =>{
        event.preventDefault();
        this.setState({
            feeStructureId:'',
            description:'',
            default:false,
            updateToken: '',
            validations: {
                description: true,
            }
        },()=>this.props.isClearForm());
    }

    handleSaveClick(event){
        event.preventDefault();
        let UserID = localStorage.getItem('UserID'); 
        var feeStructureId = this.state.feeStructureId;
        if(feeStructureId ==''){
            feeStructureId = 0;
        }
        var objectFilter = {                
            feeStructureId: feeStructureId,
            description: this.state.description,
            default: this.state.default,
            updateToken: this.state.updateToken,
            userID: UserID
        }

        if(this.validateRequiredInputs()){
            saveBNFeeStructure(objectFilter).then(
                (json) => {
                    if (json.status !== 200){
                        var alertMsg = 'An error occurred while trying to save the Fee Structure. Please try again.'
                        if(json.httpErrorMessage !== undefined && json.httpErrorMessage !== ''){
                            alertMsg = json.httpErrorMessage;
                        }
                        this.setState({showAlert: true, alertMessage: alertMsg, alertTitle: 'Error'});
                    } else {
                        this.setState({
                            feeStructureId:'',
                            description:'',
                            default:false,
                            updateToken: '',
                            showAlert: true, alertTitle: 'Fee Structure successfully saved.'});
                        this.props.updateCategoryTable();
                    }
                }
            );
        }
    }

    closeAlert(){
        this.setState({showAlert: false, alertTitle: ''});
    }
    closeAlert2(){
        this.setState({showAlertError: false, alertTitle: ''});
    }

    //Inputs Validations
    validateRequiredInputs(){
        const fields = [
            {displayName:'Description', validateName: 'description', value:this.state.description, type: 'string'}
        ]

        const [valid, validations, errors] = validate(fields);

        this.setState({validations: {...this.state.validations, ...validations}});

        if (!valid) {
            this.setState({
                showAlertError: true, alertTitle: 'Error', alertMessage: 'Please fill all mandatory fields:', errors
            });
        }

        return valid;
    }

    render(){
        return(
            <div>
                <form className="uk-form-stacked uk-grid">
                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="form-fee-structure-description" style={style.boldLabel}>Fee Description (*)</label>
                            <div className="uk-form-controls">
                                <input className={formatValidInput(this.state.validations.description)} id="form-fee-structure-description" type="text" placeholder="Fee Description" value={this.state.description}  onChange={this.handleUpdateDescription.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked uk-margin" style = {{marginBottom:'0px'}}>
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="form-fee-structure-default"><input className="uk-checkbox" type="checkbox" checked={this.state.default} onChange={this.handleUpdateDefault.bind(this)}/> Default Fee</label>                          
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked"></div>
                    <div className="uk-width-2-2 uk-margin">
                        <button className="uk-button uk-button-green" onClick={this.handleClearClick.bind(this)}>Clear Fields</button>
                        <button className="uk-button uk-button-green" onClick={this.handleSaveClick.bind(this)}>Save</button>
                        <hr/>
                    </div>
                    <AlertBox open={this.state.showAlert} onClose={this.closeAlert.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.closeAlert.bind(this)}/>
                    <AlertBox open={this.state.showAlertError} onClose={this.closeAlert2.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} messageBoldList={this.state.errors} type="Ok" okClick={this.closeAlert2.bind(this)}/>
                </form>
            </div>
        )
    }
}